import React from 'react';
import {View, Text} from 'react-native';

import {makeStyles, Divider} from 'react-native-elements'; // rne-netzon replaced

import {colorPalette} from '../../../core/config/color.config';
import { StyleSheet } from 'react-native';

interface TableHeaderRowProps {
  children: React.ReactNode;
}

const TableHeaderRow = (props: TableHeaderRowProps) => {

  return (
    <>
      <View style={styles.rootContainer}>{props.children}</View>
      <Divider style={styles.divider} />
    </>
  );
};

const styles = StyleSheet.create({
  rootContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 58,
  },
  divider: {
    height: 1,
    backgroundColor: colorPalette.light,
  },
});

export default TableHeaderRow;
